import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  rating: number;
  category: string;
  tags: string[];
  status: string;
  chapters: number;
  views: number;
  isHot?: boolean;
  isNew?: boolean;
}

export default function ComicCard({ id, title, author, coverImage, rating, category, tags, status, chapters, views, isHot, isNew }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={coverImage}
          alt={`${title} - 韩国漫画`}
          title={`${title} - 免费在线韩国漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

        {isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
            热门
          </span>
        )}
        {isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-background-50 whitespace-nowrap">
            新作
          </span>
        )}

        <div className="absolute bottom-2 left-2 right-2">
          <div className="flex items-center gap-1 text-xs text-white/90">
            <i className="ri-star-fill text-accent-500 w-3 h-3 flex items-center justify-center"></i>
            <span className="font-semibold">{rating}</span>
            <span className="ml-auto">{chapters}话</span>
          </div>
        </div>

        <div className="absolute top-2 right-2">
          <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
            status === "连载中" ? "bg-primary-500/90 text-white" : "bg-foreground-700/80 text-white"
          }`}>
            {status}
          </span>
        </div>
      </div>

      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 whitespace-nowrap overflow-hidden text-ellipsis">
        {title}
      </h3>
      <p className="text-xs text-foreground-600 mt-1 whitespace-nowrap">{author}</p>
      <div className="flex items-center gap-1 mt-1 flex-wrap">
        {tags.slice(0, 2).map((tag) => (
          <span key={tag} className="text-[10px] text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded whitespace-nowrap">
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}